export const dashboardCounterDefaults = {
  titleSize: '1.6rem',
  labelSize: '0.95rem',
  valueSize: '2.1rem',
}
